import { Stack, Typography } from "@mui/material";

export const MetrixItem = ({
  rate,
  title,
  maxRate = 5,
}: {
  rate: number | null;
  title: string;
  maxRate?: number;
}) => {
  return (
    <Stack gap="8px" flex="1 1 calc(50% - 40px)">
      <Typography variant="body1" color="custom.textDarkBlue">
        {title}
      </Typography>
      <Stack flexDirection="row" gap="8px" alignItems="center">
        <Stack
          gap="8px"
          sx={{
            width: "100%",
            maxWidth: "100%",
            height: "16px",
            backgroundColor: "#F7F7F7",
          }}
        >
          <span
            style={{
              width: "100%",
              maxWidth: `${(rate || 0) * (100 / maxRate)}%`,
              height: "100%",
              backgroundColor: "#1B3967",
            }}
          ></span>
        </Stack>
        <Typography variant="body1" color="custom.textDarkBlue">
          {rate || 0}
        </Typography>
      </Stack>
    </Stack>
  );
};
